import React from 'react'

const UpdateContractStatusDialogContext = React.createContext()

export default UpdateContractStatusDialogContext
 